<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="error"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :withEmplyFields="true"
                           :title="'editionFacture.problemOccurred'"
                           @close="error = $event"/>
      <div class="columns">
        <div class="column is-8">
          <div class="title is-5">
            <span v-if="commandes.length === 1">
              {{ $t('detail.commande.selectionEcheances.title') }} {{ commandes[0].code }}
            </span>
            <span v-else>
              {{ $t('detail.commande.selectionEcheances.titleMulti') }}
            </span>
          </div>
        </div>
        <div class="column is-4">
          <div class="columns justify-content-flex-end">
            <div class="column is-narrow">
              <button class="button is-cancel has-text-centered"
                      @click="$parent.close()">
                {{ $t('detail.commande.selectionEcheances.cancel')}}
              </button>
            </div>
            <div class="column is-narrow has-text-centered">
              <button class="button is-addOrEdit has-text-centered"
                      @click="facturer">
                {{ $t('detail.commande.selectionEcheances.charge')}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="commandes.length === 1
          ? $t('detail.commande.selectionEcheances.billDate')
          : $t('detail.commande.selectionEcheances.billsDate')"
                   class="obligatoire">
            <b-datepicker show-week-number
                          v-model="dateFacture"
                          :editable="true"
                          nearby-selectable-month-days
                          icon="calendar-today"/>
          </b-field>
        </div>
        <div class="column is-3 is-offset-6">
          <b-field :label="$t('detail.commande.selectionEcheances.repartitionLibelle')">
            <b-select expanded v-model="calculeEnQuantite" :disabled="isDisabled">
              <option :value=true>
                {{ $t('detail.commande.selectionEcheances.repartitionItem.quantite') }}
              </option>
              <option :value=false>
                {{ $t('detail.commande.selectionEcheances.repartitionItem.prixUnitaire') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12">
          <qd-checkbox v-model="genererFactureZero">
            <span class="has-text-weight-bold has-text-default">
              {{ $t('detailCommande.facturer.actions.genererFactureZero') }}
            </span>
          </qd-checkbox>
        </div>
        <div class="column is-12">
          <qd-checkbox v-model="onlyOneFacture">
            <span class="has-text-weight-bold has-text-default">
              {{ $t('detailCommande.facturer.actions.genererUneSeuleFacture') }}
            </span>
          </qd-checkbox>
        </div>
        <div class="column is-12">
          <qd-checkbox v-model="redirigerVersFacture">
            <span class="has-text-weight-bold has-text-default">
              {{ $t('detailCommande.facturer.actions.redirectionFacture') }}
            </span>
          </qd-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatIsoDate from '@/services/general/formatIsoDate';
import { factureGeneration } from '@/api/facture';
import validationCreationfacture from '@/services/devisCommandes/validation/validationCreationFacture';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsCommandeTranslator';
import validationChampsObligatoireFacture from '@/services/devisCommandes/validation/validationChampsObligatoireFacture';

export default {
  name: 'popUpParametrageFacturation',
  props: {
    commandes: {
      required: true,
      type: Array,
    },
    parutionId: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      calculeEnQuantite: true,
      dateFacture: new Date(),
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      genererFactureZero: false,
      redirigerVersFacture: true,
      onlyOneFacture: false,
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    isDisabled() {
      let status = false;
      this.commandes.forEach((commande) => {
        const hasEcheance = commande.echeancesLignes.find((echeance) => {
          return echeance.tarifUnitaire;
        });
        if (hasEcheance) status = true;
      });
      if (status) this.setRepartition();
      return status;
    },
  },
  methods: {
    setRepartition() {
      this.calculeEnQuantite = false;
    },
    async facturer() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.error = false;
      try {
        const dateFactureIso = formatIsoDate(this.dateFacture);
        const ids = [];
        this.commandes.forEach((commande) => {
          commande.echeancesLignes.forEach((echeance) => {
            ids.push(echeance.id);
          });
        });
        const factures = (await factureGeneration({
          listeEcheancierLigneId: ids,
          genererUneSeuleFacture: this.onlyOneFacture,
          dateFacturation: dateFactureIso,
          calculeEnQuantite: this.calculeEnQuantite,
          genererFactureZero: this.genererFactureZero,
        })).data.result;
        if (factures && factures.length === 1 && this.redirigerVersFacture) {
          await this.$router.push({ name: 'c.bodac.factures', params: { id: factures[0].id } });
        } else if (factures && factures.length > 1 && this.redirigerVersFacture) {
          if (this.parutionId) await this.$router.push({ name: 'l.bodac.factures-par-parution', params: { parutionId: this.parutionId } });
          else await this.$router.push({ name: 'l.bodac.factures' });
        } else this.$emit('closeWithReload');
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          validationCreationfacture(e.response, this.messages);
          validationChampsObligatoireFacture(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>

<style scoped>

</style>
